import { Button } from '@/components/ui/shadcn/button'
import { CheckCircle2 as CheckCircleIcon } from 'lucide-react'

export default function BillingSuccess({ selectedTier, handleClose }) {
  return (
    <div className="grid gap-4">
      <div className="flex justify-center">
        <CheckCircleIcon className="size-16 text-green-600" />
      </div>
      <div>
        <h5 className="text-xl font-semibold text-center mb-2">
          Tier Updated Successfully!
        </h5>
      </div>
      <div>
        <p className="text-muted-foreground text-center mb-4">
          Your organization has been updated to the {selectedTier?.name} tier.
        </p>
      </div>
      <div className="flex justify-end">
        <Button
          onClick={handleClose}
          className="bg-green-600 hover:bg-green-700 text-white"
        >
          Close
        </Button>
      </div>
    </div>
  )
}
